import api from './api';

export interface VentasRpt01Row {
  nroIdformulario?: number | null;
  fecha?: string | null;
  nroItem?: number | null;
  iteCodigoArticulo?: string | null;
  iteDescripcion?: string | null;
  iteCantidad?: number | null;
  precioUnitario?: number | null;
  precioUnitarioFinal?: number | null;
  subtotal?: number | null;
  subtotalFinal?: number | null;
  nroFormulario?: number | null;
  nroTipoFormulario?: string | null;
  letra?: string | null;
  nroSuc?: number | null;
  nroComprobante?: number | null;
  fechaEmision?: string | null;
  fechaVencim?: string | null;
  nroCliente?: number | null;
  nombre?: string | null;
  cliNombre?: string | null;
  cuit?: string | null;
  cliCuit?: string | null;
  tipoIva?: string | null;
  forDescripcion?: string | null;
  tipDescripcion?: string | null;
  tipArea?: string | null;
  nroUbicacion?: number | null;
  entradaSalida?: string | null;
  importeTotal?: number | null;
  importeSinIva?: number | null;
  forSubtotal?: number | null;
  forDescuento?: number | null;
  exento?: number | null;
  ivainscripto?: number | null;
  ivanoInscripto?: number | null;
  ivaotro?: number | null;
  percepciones?: number | null;
  formaDePago?: string | null;
  codigoArticulo?: string | null;
  descripcion?: string | null;
  idUnidadMedida?: string | null;
  nombreRamo?: string | null;
  nombreLinea?: string | null;
  nombreClase?: string | null;
  venNombreVendedor?: string | null;
  forNroVendedor?: number | null;
  usuario?: string | null;
  liquidado?: string | null;
  facturado?: string | null;
  nroRemito?: string | null;
  iteCosto?: number | null;
  descuento?: number | null;
  bonificacion?: number | null;
  ciuNombreCiudad?: string | null;
  pciaNombreProvincia?: string | null;
  rutNombreRuta?: string | null;
  iteCentroCosto?: number | null;
  codBarra?: string | null;
  tipoArticulo?: string | null;
  asentado?: string | null;
  tasa1?: number | null;
  tasa2?: number | null;
  /** Peso total línea (kg), desde BP_RPT_Ventas01 */
  pesoTotalKg?: number | null;
  /** Volumen total línea (m³) */
  volumenTotalM3?: number | null;
}

export interface VentasRpt01Response {
  data: VentasRpt01Row[];
  totalMatched: number;
  truncated: boolean;
}

export interface GetRptVentas01Params {
  fechaDesde: string;
  fechaHasta: string;
  nroCliente?: number;
  codigoArticulo?: string;
  nroTipoFormulario?: string;
  nroSuc?: number;
  maxRows?: number;
}

export interface VentasResumenProductoRow {
  producto: string;
  tipo?: string | null;
  nombreRamo?: string | null;
  nombreLinea?: string | null;
  nombreClase?: string | null;
  cantidad: number;
  montoTotal: number;
  costoTotal: number;
  pesoTotal: number;
  volumenTotal: number;
}

export interface VentasResumenProductoResponse {
  data: VentasResumenProductoRow[];
  totalCantidad: number;
  totalMonto: number;
  totalCosto: number;
  totalPeso: number;
  totalVolumen: number;
  /** Comprobantes (cabeceras) distintos; ticket promedio = totalMonto / este valor. */
  cantidadComprobantesDistintos?: number;
}

export interface VentasResumenFiltrosOpciones {
  nombreRamos: string[];
  nombreLineas: string[];
  nombreClases: string[];
}

export interface GetResumenProductoParams {
  fechaDesde: string;
  fechaHasta: string;
  tipoArticulo?: string;
  nombreRamo?: string;
  nombreLinea?: string;
  nombreClase?: string;
  /** Código de artículo (coincidencia parcial en IteCodigoArticulo / CodigoArticulo). */
  codigoArticulo?: string;
  /** NroTipoFormulario separados por coma (ej. 1,2,3). */
  nroTiposFormulario?: string;
}

export interface VentasResumenDetalleRequest {
  fechaDesde: string;
  fechaHasta: string;
  producto: string;
  tipo?: string | null;
  nombreRamo?: string | null;
  nombreLinea?: string | null;
  nombreClase?: string | null;
  nroTiposFormulario?: string;
}

const ventasInformesService = {
  getOpcionesResumenProducto: async (
    fechaDesde: string,
    fechaHasta: string
  ): Promise<VentasResumenFiltrosOpciones> => {
    const query = new URLSearchParams();
    query.append('fechaDesde', fechaDesde);
    query.append('fechaHasta', fechaHasta);
    const response = await api.get<VentasResumenFiltrosOpciones>(
      `/api/VentasInformes/rpt-ventas-resumen-producto/opciones-filtros?${query.toString()}`
    );
    return response.data;
  },

  getResumenProducto: async (params: GetResumenProductoParams): Promise<VentasResumenProductoResponse> => {
    const query = new URLSearchParams();
    query.append('fechaDesde', params.fechaDesde);
    query.append('fechaHasta', params.fechaHasta);
    if (params.tipoArticulo?.trim()) {
      query.append('tipoArticulo', params.tipoArticulo.trim());
    }
    if (params.nombreRamo?.trim()) {
      query.append('nombreRamo', params.nombreRamo.trim());
    }
    if (params.nombreLinea?.trim()) {
      query.append('nombreLinea', params.nombreLinea.trim());
    }
    if (params.nombreClase?.trim()) {
      query.append('nombreClase', params.nombreClase.trim());
    }
    if (params.codigoArticulo?.trim()) {
      query.append('codigoArticulo', params.codigoArticulo.trim());
    }
    if (params.nroTiposFormulario?.trim()) {
      query.append('nroTiposFormulario', params.nroTiposFormulario.trim());
    }
    const response = await api.get<VentasResumenProductoResponse>(
      `/api/VentasInformes/rpt-ventas-resumen-producto?${query.toString()}`
    );
    return response.data;
  },

  postResumenProductoDetalle: async (
    body: VentasResumenDetalleRequest
  ): Promise<VentasRpt01Row[]> => {
    const response = await api.post<VentasRpt01Row[]>(
      '/api/VentasInformes/rpt-ventas-resumen-producto/detalle',
      {
        fechaDesde: body.fechaDesde,
        fechaHasta: body.fechaHasta,
        producto: body.producto,
        tipo: body.tipo ?? '',
        nombreRamo: body.nombreRamo ?? '',
        nombreLinea: body.nombreLinea ?? '',
        nombreClase: body.nombreClase ?? '',
        nroTiposFormulario: body.nroTiposFormulario?.trim() || undefined,
      }
    );
    return response.data;
  },

  getRptVentas01: async (params: GetRptVentas01Params): Promise<VentasRpt01Response> => {
    const query = new URLSearchParams();
    query.append('fechaDesde', params.fechaDesde);
    query.append('fechaHasta', params.fechaHasta);
    if (params.nroCliente != null && params.nroCliente !== undefined) {
      query.append('nroCliente', String(params.nroCliente));
    }
    if (params.codigoArticulo?.trim()) {
      query.append('codigoArticulo', params.codigoArticulo.trim());
    }
    if (params.nroTipoFormulario?.trim()) {
      query.append('nroTipoFormulario', params.nroTipoFormulario.trim());
    }
    if (params.nroSuc != null && params.nroSuc !== undefined) {
      query.append('nroSuc', String(params.nroSuc));
    }
    if (params.maxRows != null) {
      query.append('maxRows', String(params.maxRows));
    }

    const response = await api.get<VentasRpt01Response>(
      `/api/VentasInformes/rpt-ventas-01?${query.toString()}`
    );
    return response.data;
  },
};

export default ventasInformesService;
